<template>
  <div class="welfare">
    <div class="center wrapW">
      <swiper :options="swiperOption" class="banner_list">
        <swiper-slide class="swiperL" v-for="(i,index) in list" :key="index">
          <div class="img"><img :src="i.img"></div>
          <div class="name">{{i.name}}</div>
          <div class="info" v-html="i.desc"></div>
        </swiper-slide>
        <div class="swiper-button-prev ip1 iconfont icon-zuojiantou_huaban" slot="button-prev"></div>
        <div class="swiper-button-next ip1 iconfont icon-right-arrow-1" slot="button-next"></div>
      </swiper>
    </div>
  </div>
</template>

<script>
export default {
  name: 'welfareO',
  data () {
    return {
      list: [],
      swiperOption: {
        loop: false,
        nextButton: '.swiper-button-next.ip1',
        prevButton: '.swiper-button-prev.ip1',
        spaceBetween:10,
        autoplay: 2000
      }
    }
  },
  mounted () {
    this.getSupply()
  },
  methods: {
    getSupply () {
      let that = this
      this.$axios.get(process.env.API_HOSTT + '/os/getSupply', {
      }).then(
        function (res) {
          res = res.data.data
          that.list = res.list.rotation
        }
      ).catch(error => console.log(error))
    }
  }
}
</script>
<style lang="stylus" scoped>
.welfare
  text-align center
  background #F4F5F7
  padding .25rem 0
  padding-bottom .46rem
  .Wdescribe
    font-size .24rem
    margin-top .22rem
    color #666
    letter-spacing .04rem
  .center
    margin-top .5rem
    overflow hidden
    max-width 1544px
    .banner_list
      width 78%
      margin 0 auto
      padding .2rem 0
    .swiperL
      box-shadow 0px 0px 10px 0px rgba(9, 9, 9, 0.2)
      background #fff
      text-align center
      .img
        width 100%
        margin 0 auto
        img
          width 100%
      .name
        font-size .24rem
        color var(--hei)
        margin .50rem 0 .25rem 0
      .info
        font-size .16rem
        color #666
        line-height .25rem
        padding 0 .66rem
        margin-bottom .36rem
    .ip1
      width 14%
      height 100%
      top 0
      background-color #f4f5f7
      margin-top 0px
      font-size .38rem
      color #c6c7c9
      display flex
      align-items center
      justify-content center
    .ip1:hover
      color #D22016
    .swiper-button-prev
      left -14.2%
      background-image none
    .swiper-button-next
      right -14.2%
      background-image none
    .swiper-button-disabled
      opacity 0
    .swiper-container
      overflow initial
</style>



// WEBPACK FOOTER //
// src/pages/index/components/welfareE.vue